<template>
  <div class="page-not-found">
    Page not found
  </div>
</template>

<script>

export default {
  name: 'PageNotFound',
}
</script>

<style scoped lang="scss">
@import "@/styles/breakpoints";

.page-not-found {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
